import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Table } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { DemographicsCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/DemographicsCloums';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { DateColumns, renderDateName } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/DateCloums';
import { useIntl } from 'umi';
import { ageAddPreText } from '../../_config/utils';
import { PAGE_TYPE_AGE } from '../../_config/constant';
import { growthFormat } from '@/pages/intelligence/utils/commonUtils';
const { pageable, scrollable } = Table.addons;

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    tableHeaderOptions,
    dateType,
    pageType,
    onTableSortChage,
    pageSortAttr: defaultPageSortAttr,
    rangeTimeType,
    startDate,
    endDate,
    disableSort,
  } = props;

  const { formatMessage } = useIntl();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState(defaultPageSortAttr);

  useEffect(() => {
    if (disableSort) {
      setSortTableData(tableData);
      setPageSortAttr(defaultPageSortAttr);
      return;
    }
    onSortChage({
      sortMetric: defaultPageSortAttr?.currentSortMetric,
      sortVal: defaultPageSortAttr?.currentSortValue,
      ratioType: defaultPageSortAttr?.currentRatioType,
    });
    setPageSortAttr(defaultPageSortAttr);
  }, [tableData, defaultPageSortAttr, disableSort]);

  const handleSortChange = (e: SortByItemType) => {
    if (disableSort) {
      return;
    }
    onTableSortChage?.(e);
    onSortChage(e);
  };
  const onSortChage = (e: SortByItemType) => {
    const ratioType = (e?.ratioType ?? 0) as 0 | 1;
    const sortVal = (e?.sortVal || 'desc') as 'desc' | 'asc';
    const sortMetric = e?.sortMetric || 'date';

    setPageSortAttr({
      currentSortValue: sortVal,
      currentSortMetric: sortMetric,
      currentRatioType: ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData,
      sortParams: {
        sortMetric,
        sortVal,
        ratioType,
      },
      timeProperty: 'date',
      metricProperty: 'metric',
      growthProperty: 'dod',
    });
    setSortTableData(sortTable);
  };

  const getMetricValueOfCvm = (cvm: any, metricKey: string) => {
    const metrics = cvm?.metrics || [];
    const metric = metrics.find((item: any) => {
      return item?.metric === metricKey;
    });
    const value = growthFormat({
      value: metric?.value,
      valueType: 'pointValue',
      hasPoint: 'all',
      fixedNum: 1,
      maxNumber: 99999,
      zeroValue: '0% -',
    });
    const growthDataObj = growthFormat({
      value: metric?.dod,
      valueType: 'pointValue',
      hasPoint: 'all',
      fixedNum: 1,
      maxNumber: 99999,
      zeroValue: '0% -',
    });
    return {
      value: value.value,
      growthDataObj,
    };
  };
  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    // DAU Revenue Download 每个数据源赋值一遍
    tableHeaderOptions?.forEach((t: any) => {
      metricCloums.push(
        DemographicsCloums({
          title: pageType === PAGE_TYPE_AGE ? ageAddPreText(t.text) : t.text,
          key: `${t.value}`,
          sortMetric: t.value,
          currentSortValue: pageSortAttr?.currentSortValue,
          currentSortKey: `${pageSortAttr?.currentSortMetric}_${pageSortAttr?.currentRatioType}`,
          onSortChage: handleSortChange,
          getMetricValueOfCvm,
          formatMessage,
          isNoDropdown: disableSort,
        } as any),

      );
    });
    return metricCloums;
  };

  return (
    <>
      <Table
        //   verticalTop
        bordered="all"
        records={sortTableData}
        className="dbi-mobileGames-details-table"
        columns={[
          DateColumns({
            key: 'date',
            sortMetric: 'date',
            title: formatMessage({ id: `dbi_date` }),
            currentSortMetric: pageSortAttr?.currentSortMetric,
            currentSortValue: pageSortAttr?.currentSortValue,
            dateType,
            onSortChage: handleSortChange,
            width: 215,
            isNoDropdown: disableSort,
            renderFunction: (cvm: any) => {
              const rawDate = cvm?.date;
              const rawDateStr = rawDate == null ? '' : String(rawDate);
              const val = rawDateStr?.toLocaleLowerCase?.();
              if (['sum', 'max', 'avg']?.includes(val)) {
                return renderDateName(rawDateStr, dateType, '');
              }

              // 仅本页面：lifetime 展示起止时间段；quarter 展示 YYYY-QN
              if (rangeTimeType === 'lifetime') {
                if (startDate && endDate) {
                  return `${startDate} ~ ${endDate}`;
                }
              }
              if (rangeTimeType === 'quarter') {
                // 按行 date 计算季度：1月=Q1，4月=Q2，7月=Q3，10月=Q4
                const m = moment(rawDateStr || startDate || endDate);
                if (m.isValid()) {
                  return m.format('YYYY-[Q]Q');
                }
              }

              return renderDateName(rawDateStr, dateType, '');
            },
          }),

          ...getMetricCloums(),
        ]}
        addons={[
          pageable({
            stateTextVisible: true,
            pageSizeVisible: sortTableData?.length > 5,
            pageIndexVisible: sortTableData?.length > 5,
            jumpVisible: sortTableData?.length > 5,
            endJumpVisible: sortTableData?.length > 5,
            // pageSizeOptions: [5, 10, 15],
            stateText: formatMessage(
              { id: 'dbi_pagination_total' },
              { total: sortTableData?.length ?? 0 },
            ),
          }),
          scrollable({
            //   maxHeight: 580,
            // minWidth: 2500
            //     tHeaderList?.length > 3
            //       ? 220 * tHeaderList?.length + 300
            //       : 'auto',
          }),
        ]}
      />
    </>
  );
};

export default TrendsCard;
